
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Config from "@/config/config";
import vuexStore from "@/store/vuex-store";
import Count from "@/lib/model/stock/count";
import Auth from "@/lib/common/auth";
import Company from "@/lib/model/company/company";
import User from "@/lib/model/user/user";
import Url from "@/lib/common/url";
import { Permission } from "@/lib/model/common";
import { CompanySpecialConfig } from "@/lib/model/exam/candidate-answer";
import CheckUserChange from "@/components/check-user-change.vue";

@Component({ components: { CheckUserChange } })
export default class AuthHeader extends Vue {
  name = "auth-header";
  underLine = false;
  @Prop({ type: Boolean, default: false }) isMarkPage!: boolean;
  vuexStores = vuexStore;
  count = new Count();
  companies: Company[] = [new Company()];
  token = Auth.token;
  currentCompanyId = 0;
  currentCompanyName = "";
  companyLoading = false;
  userInfo: User = new User();
  logoutLoading = false;
  companyInfo = new Company();
  // isFSK = true;
  showSelectCompany = false; //切换公司
  showSelectHina = false; //切产品
  intoC = false;
  showSelectCompanyTimer = 0; //延迟隐藏
  showSelectHinaTimer = 0;
  companyVersion = ""; //公司面试版本 0331

  type = 1;
  CP = new CompanySpecialConfig();
  flagAi = false;
  async created() {
    if (
      //匿名登录页面： 阅卷 报告（新版报告页现已移出主路由 不会加载head和side了）
      this.$route.name === "paper-mark" ||
      this.$route.name === "paper-mark-mobile" ||
      this.$route.name === "candidate-info" ||
      this.$route.name === "candidates-info"
    )
      return;
    if (!Auth.token) {
      this.$router.push("/");
    } else {
      await this.authInit();
    }

    this.$emit("userInfoReady", true);
  }
  mounted() {
    // (this.$refs["bg"] as any)?.style?.setProperty("--top-bg", "#525fff");
    // const aa = (this.$refs["bg"] as any)
  }
  get isHire360() {
    return window.location.host.includes("hire360");
  }
  get logoUrl() {
    this.setCompanyLink();
    return (
      this.vuexStores.company.logoUrl ||
      this.vuexStores.user.viConfig.specialLogoOss
    );
  }
  get getRoleName() {
    return this.companyInfo.roleName ?? "其他类型成员";
  }

  get vuexShowCompany() {
    return this.vuexStores.showCompany;
  }
  //vuex里的 卡片显隐
  @Watch("vuexShowCompany")
  VXC(n: boolean) {
    if (n) return;
    this.showSelectHina = n;
    this.showSelectCompany = n;
  }

  toHome() {
    window.location.href = `${Config.apiUrl}/content`;
  }
  get setWeb(): boolean {
    return this.$route?.query?.teamUse === "setWeb";
  }

  get canUseV2() {
    return (
      this.companyInfo.aiExamVersionList.includes("2") ||
      this.companyInfo.aiExamVersionList.includes("3")
    );
  }

  get showChangeSwitch() {
    //0331开setweb才可以切换
    return (
      this.flagAi &&
      (this.companyVersion === "" ||
        (this.companyVersion === "0331" && this.setWeb))
    );
  }

  changeType(type = 1) {
    if (type === 1) {
      localStorage.setItem("isWorker", "false");
      this.$message.success("已切换成通用版");
      this.$router.push("/");
    } else if (type === 2) {
      localStorage.setItem("isWorker", "true");
      this.$message.success("已切换成普工版");
      this.$router.push("/");
    } else {
      window.open(`${Config.aiInterviewHost}/v2`);
    }
  }

  //获取 公司列表与当前公司信息 和 用户权限
  async authInit() {
    await Auth.init(false)
      .then(() => {
        this.currentCompanyId = parseInt(this.vuexStores.company.id);
        Auth.companyId = this.vuexStores.company.id;
        Auth.companyList = this.vuexStores.companies;
        this.currentCompanyName = this.vuexStores.company.name;
        this.companies = this.vuexStores.companies;
        this.companyLoading = false;
        this.companyInfo = this.vuexStores.company;
        this.companyVersion = this.vuexStores.companyPower.version;

        if (!this.companyInfo.aiExamVersionList.includes("1")) {
          window.location.href = `${Config.aiInterviewHost}/v2`;
          return;
        }

        //是否新版AiBuilder 特判是的id
        this.flagAi =
          ([
            80976,
            82070,
            80978,
            559,
            80933,
            80934,
            80935,
            81022,
            81023,
            81025,
            81027,
            81041,
            81044,
            81043,
            81042,
            81040,
            81039,
            89792,
            81177,
            81175,
            81191,
            81190,
            81189,
            81188,
            3
          ].includes(Number(Auth.companyId)) ||
            Number(Auth.companyId) >= 91353) &&
          ![91415, 194].includes(Number(Auth.companyId));
        // && !this.isFSK 不是富士康模式公司id（旧判法）
        //是否AIbuilder公司
        this.vuexStores.updateIsNewAi(this.flagAi);
      })
      .then(() => {
        this.userInfo = this.vuexStores.user;
      })
      .catch(() => {
        this.companyLoading = false;
      })
      .finally(async () => {
        try {
          if (this.userInfo) {
            // sensors.setProfile({
            //   hinaId: this.userInfo.id,
            //   phone: this.userInfo.mobile,
            //   email: this.userInfo.email,
            //   userName: this.userInfo.username,
            //   nickName: this.userInfo.nickname
            // });
            // sensors.login("uc_" + this.userInfo.id);
          }
          // sensors.setProfile({
          //   company_id: this.currentCompanyId,
          //   company_name: this.currentCompanyName
          // });
        } catch (e) {
          console.log(e);
        }

        // if (parseInt(this.userInfo.threatDegree) > 7) {
        //   //无AI面试使用权限
        //   this.$router.push("/no-auth").catch(err => err);
        // }
        //判断条件改变  threatDegree大于7 -> isEnableAI
        if (!this.companyInfo.isEnableAI) {
          //无AI面试使用权限
          this.$router.push("/no-auth").catch(err => err);
        }
        this.companyLoading = false;
        //获取用户权限
        await Permission.getPerm().then(p => {
          this.CP = p.companySpecialConfig;

          //判断版本
          if (!this.flagAi) {
            //非AIbuilder公司 worker设为false
            this.vuexStores.updateIsWorker(false);
          } else {
            //AIbuilder公司 先判权限
            if (
              this.CP.enableAibuilderExam !== 1 &&
              this.CP.enableWorkerExam !== 1
            ) {
              //都没开
              this.$message.error("用户公司未开通任何版本服务");
              return;
            } else if (
              this.CP.enableAibuilderExam === 1 &&
              this.CP.enableWorkerExam !== 1
            ) {
              //只开了通用
              this.vuexStores.updateIsWorker(false);
              this.type = 1;
              return;
            } else if (
              this.CP.enableAibuilderExam !== 1 &&
              this.CP.enableWorkerExam === 1
            ) {
              //只开了普工
              this.vuexStores.updateIsWorker(true);
              this.type = 2;
              return;
            } else {
              //都开
              const cacheIsWorker = localStorage.getItem("isWorker");
              if (cacheIsWorker) {
                //有缓存先判缓存 普工or通用
                this.vuexStores.updateIsWorker(cacheIsWorker === "true");
                this.type = cacheIsWorker === "true" ? 2 : 1;
              } else {
                this.vuexStores.updateIsWorker(false); //无则 默认通用版
                this.type = 1;
              }
            }
          }
        });
      });
  }
  //切换公司
  selectCompany(comItem: Company) {
    this.companyLoading = true;
    localStorage.removeItem("aibuildercachev1"); //清一下新建面试缓存
    localStorage.removeItem("aibuildercachev3");
    this.vuexStores.updateCompany(comItem);
    Auth.changeCom(comItem.id);
    Url.setQuery("cid", comItem.id);
    Url.setQuery("companyId", comItem.id);
    Auth.companyId = comItem.id;
    this.currentCompanyName = comItem.name;
    this.companyLoading = false;
    if (comItem.companyType === "0") {
      this.$router.push("/");
      this.$nextTick(() => {
        this.$router.go(0); //实例重建
      });
    } else if (location.hostname !== "localhost") {
      window.open(
        Config.accountUrl + "/#/user?companyId=" + comItem.id,
        "_self"
      );
    }

    this.vuexStores.updateShowCompany(false);
  }

  logOut() {
    window.sessionStorage.removeItem("fromAdmin");
    Auth.logout();
    this.logoutLoading = true;
    setTimeout(() => {
      window.location.reload();
    }, 1000);
  }

  toPersonal() {
    window.open(Config.accountUrl + "/#/user?companyId=" + Auth.companyId);
  }

  toSystem(name: string) {
    let sysUrl = "";
    switch (name) {
      case "vi":
        sysUrl = "https://vi.hina.com/main/project/index-interview";
        break;
      case "exam":
        sysUrl = "https://exam.hina.com";
        break;
      case "saas":
        sysUrl = "https://hr.hina.com";
        break;
      default:
        break;
    }
    if (sysUrl) {
      window.open(sysUrl);
      this.showSelectHina = false;
    }
  }
  showCompany() {
    this.vuexStores.updateShowCompany(!this.vuexStores.showCompany);
  }
  //延迟隐藏
  laterHide(d: string) {
    this[d + "Timer"] = setTimeout(() => {
      this[d] = false;
    }, 200);
    console.log(this[d + "Timer"]);
  }
  //进入list 取消延迟隐藏
  cancelHide(d: string) {
    this[d] = true;
    clearTimeout(this[d + "Timer"]);
  }
  showUdesk() {
    //
  }
  setCompanyLink() {
    const company = this.vuexStores.company;
    if (company.shortname) {
      document.title = company.shortname.substring(0, 6);
    }
    if (company.companyIcon) {
      let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
      if (!link) {
        link = document.createElement("link") as HTMLLinkElement;
      }
      if (link) {
        link.rel = "icon";
        link.href = company.companyIcon;
        document.head.appendChild(link);
      }
    }
  }
}
